import React, { useEffect, useState } from 'react'
import { connect } from 'react-redux'
import { Formik, Form, Field } from 'formik'
import * as Yup from 'yup'
import { t } from 'translation'

import AuthErrorBox from 'components/Auth/AuthErrorBox'
import LoadingButton from 'components/ui/LoadingButton/LoadingButton'

import CheckboxItem from 'components/CheckboxItem/CheckboxItem'

import { authFail, resetAuthError } from 'store/actions'

import { contactApi } from 'api'

const contactSchema = Yup.object().shape({
  firstName: Yup.string()
    .required('FIRST_NAME_IS_REQUIRED')
    .max(80, 'FIRST_NAME_IS_TOO_LONG'),
  lastName: Yup.string()
    .max(80, 'LAST_NAME_IS_TOO_LONG')
    .required('LAST_NAME_IS_REQUIRED'),
  firm: Yup.string().max(256, 'LAST_NAME_IS_TOO_LONG').required('FIRM_IS_REQUIRED'),
  project: Yup.string().max(256, 'LAST_NAME_IS_TOO_LONG'),
  message: Yup.string().required('MESSAGE_IS_REQUIRED').max(1000, 'MESSAGE_IS_TOO_LONG'),
  email: Yup.string().email('INVALID_EMAIL').required('EMAIL_IS_REQUIRED'),
  telephone: Yup.string()
    .max(16, 'TELEPHONE_IS_TOO_LONG')
    .required('TELEPHONE_IS_REQUIRED'),
})

const ContactFormSales = function ContactForm({
  authError,
  authFail,
  resetAuthError,
  formSubmit,
  setStatus,
}) {
  const [success, setSuccess] = useState(false)
  const [disableEnterKey, setDisableEnterKey] = useState(false)

  useEffect(() => {
    document.documentElement.classList.add('no_scale_mod')
  }, [])

  return (
    <Formik
      initialValues={{
        firstName: '',
        lastName: '',
        email: '',
        telephone: '',
        message: '',
        firm: '',
        project: '',
        type: 'sales',
        commercial: false,
        newsletter: false,
      }}
      validationSchema={contactSchema}
      onSubmit={async (values, { setSubmitting }) => {
        formSubmit(true)
        resetAuthError()

        const { error } = await contactApi.createSalesTicket({
          ...values,
          telephone: values.telephone.replace(/[^0-9]/g, ''),
        })

        if (!error) return setSuccess(true), setStatus(true)

        authFail('UNABLE_TO_SEND_MESSAGE')
        setSubmitting(false)
      }}
    >
      {({ errors, touched, submitForm, setFieldValue, isSubmitting, handleChange }) => (
        <Form className="tab_content login_mod active_tab contact_form">
          <div className="form_controller login_mod">
            <dl className="form_cell form_cell_v1_mod">
              <dd className="form_field_wrap form_v3_mod">
                <Field
                  className={`form_field v4_mod ${
                    errors.firstName && touched.firstName ? 'error' : ''
                  }`}
                  type="text"
                  name="firstName"
                  id="first-name"
                  placeholder={t('contactForm.FIRST_NAME')}
                  disabled={isSubmitting || success}
                  onChange={(e) => (resetAuthError(), handleChange(e))}
                />
              </dd>
            </dl>
          </div>
          <div className="form_controller login_mod">
            <dl className="form_cell form_cell_v1_mod">
              <dd className="form_field_wrap form_v3_mod">
                <Field
                  className={`form_field v4_mod ${
                    errors.lastName && touched.lastName ? 'error' : ''
                  }`}
                  type="text"
                  name="lastName"
                  id="last-name"
                  placeholder={t('contactForm.LAST_NAME')}
                  disabled={isSubmitting || success}
                  onChange={(e) => (resetAuthError(), handleChange(e))}
                />
              </dd>
            </dl>
          </div>
          <div className="form_controller login_mod">
            <dl className="form_cell form_cell_v1_mod">
              <dd className="form_field_wrap form_v3_mod">
                <Field
                  className={`form_field v4_mod ${
                    errors.email && touched.email ? 'error' : ''
                  }`}
                  type="email"
                  name="email"
                  id="email"
                  placeholder={t('contactForm.EMAIL_PRO')}
                  disabled={isSubmitting || success}
                  onChange={(e) => (resetAuthError(), handleChange(e))}
                />
              </dd>
            </dl>
          </div>
          <div className="form_controller login_mod">
            <dl className="form_cell form_cell_v1_mod">
              <dd className="form_field_wrap form_v3_mod">
                <Field
                  className="form_field v4_mod"
                  type="text"
                  name="telephone"
                  id="telephone"
                  placeholder={t('contactForm.TELEPHONE')}
                  disabled={isSubmitting || success}
                  onChange={({ target: { value } }) => (
                    resetAuthError(),
                    /^[0-9\s+()]{0,16}$/g.test(value) && setFieldValue('telephone', value)
                  )}
                />
              </dd>
            </dl>
          </div>
          <div className="form_controller login_mod">
            <dl className="form_cell form_cell_v1_mod">
              <dd className="form_field_wrap form_v3_mod">
                <Field
                  className={`form_field v4_mod ${
                    errors.firstName && touched.firstName ? 'error' : ''
                  }`}
                  type="text"
                  name="firm"
                  id="firm"
                  placeholder={t('contactForm.FIRM')}
                  disabled={isSubmitting || success}
                  onChange={(e) => (resetAuthError(), handleChange(e))}
                />
              </dd>
            </dl>
          </div>
          <div className="form_controller login_mod">
            <dl className="form_cell form_cell_v1_mod">
              <dd className="form_field_wrap form_v3_mod">
                <Field
                  className={`form_field v4_mod ${
                    errors.firstName && touched.firstName ? 'error' : ''
                  }`}
                  type="text"
                  name="project"
                  id="project"
                  placeholder={t('contactForm.PROJECT')}
                  disabled={isSubmitting || success}
                  onChange={(e) => (resetAuthError(), handleChange(e))}
                />
              </dd>
            </dl>
          </div>
          <div className="form_controller login_mod">
            <dl className="form_cell form_cell_v1_mod">
              <dd className="form_field_wrap form_v3_mod">
                <Field
                  as="textarea"
                  className={`form_field v4_mod textarea_mod ${
                    errors.message && touched.message ? 'error' : ''
                  }`}
                  type="textarea"
                  name="message"
                  id="message"
                  placeholder={t('contactForm.MESSAGE')}
                  disabled={isSubmitting || success}
                  onChange={(e) => (resetAuthError(), handleChange(e))}
                  onBlur={() => setDisableEnterKey(false)}
                  onFocus={() => setDisableEnterKey(true)}
                />
              </dd>
            </dl>
          </div>

          <div className="form_controller login_mod">
            <CheckboxItem
              name="commercial"
              id="commercial"
              label={
                <>
                  {t('contactForm.COMMERCIAL_INFO_1')}
                  <a
                    href="https://www.music.care/politiques.html"
                    target="_blank"
                    rel="noopener"
                  >
                    {t('contactForm.CONTACT_LINK')}
                  </a>
                  {t('contactForm.COMMERCIAL_INFO_2')}
                </>
              }
              disabled={isSubmitting || success}
              onChange={(e) => (resetAuthError(), handleChange(e))}
            />
          </div>
          <div className="form_controller login_mod">
            <CheckboxItem
              name="newsletter"
              id="newsletter"
              label={
                <>
                  {t('contactForm.NEWSLETTERS_INFO_1')}
                  <a
                    href="https://www.music.care/politiques.html"
                    target="_blank"
                    rel="noopener"
                  >
                    {t('contactForm.CONTACT_LINK')}
                  </a>
                  {t('contactForm.NEWSLETTERS_INFO_2')}
                </>
              }
              disabled={isSubmitting || success}
              onChange={(e) => (resetAuthError(), handleChange(e))}
            />
          </div>
          {success ? (
            <div className="form_success">{t(`contactForm.SEND_SUCCESS`)}</div>
          ) : null}
          {!success && (
            <AuthErrorBox
              formFields={[
                'firstName',
                'lastName',
                'telephone',
                'firm',
                'email',
                'message',
              ]}
              formTouched={touched}
              formErrors={errors}
              apiResponseError={authError || ''}
              resetApiResponseError={resetAuthError}
              namespace={'contactForm'}
            />
          )}
          <div className="login_bottom">
            <LoadingButton
              className="btn_base_v1"
              id="login_submit"
              isLoading={isSubmitting}
              onClick={submitForm}
              disabled={success}
              type="submit"
              disableEnterKey={disableEnterKey}
            >
              {t('contactForm.SEND_MESSAGE')}
            </LoadingButton>
          </div>
          <div className="login_descr">
            <div className="login_descr_text v2_mod">{t('contactForm.LEGAL_INFO')}</div>
          </div>
        </Form>
      )}
    </Formik>
  )
}

const mapStateToProps = ({ auth: { error } }) => ({
  authError: error,
})

const willMapDispatchToProps = { authFail, resetAuthError }

export default connect(mapStateToProps, willMapDispatchToProps)(ContactFormSales)
